import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../store/slices/authSlice';
import { unsubscribePush } from '../services/pushNotifications';

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    unsubscribePush().finally(() => {
      dispatch(logout());
      navigate('/login');
    });
  }, []);
  return null;
};
export default Logout;
